import createInstance from "./interceptors";

const API_URL = process.env.VUE_APP_API_BASE_URL + "/api";

class Supervisor {
  getFilters() {
    const instance = createInstance();

    return instance.get(API_URL + "/user/submissions").then((response) => {
      return response.data;
    });
  }

  filter(data) {
    const instance = createInstance();

    return instance
      .post(API_URL + "/user/submissions", data)
      .then((response) => {
        return response.data;
      });
  }

  search(string, page, pageSize) {
    const instance = createInstance();

    return instance
      .get(API_URL + "/user/getAlunosByString", {
        params: {
          string: string,
          page: page,
          pagesize: pageSize,
        },
      })
      .then((response) => {
        return response.data;
      });
  }

  lockStatus(id) {
    const instance = createInstance();

    return instance
      .post(API_URL + "/user/lockStatus/" + id)
      .then((response) => {
        return response.data;
      });
  }

  unlockStatus(id) {
    const instance = createInstance();

    return instance
      .post(API_URL + "/user/unlockStatus/" + id)
      .then((response) => {
        return response.data;
      });
  }

  updateStatus(data) {
    const instance = createInstance();

    return instance
      .post(API_URL + "/user/updateStatus", {
        id: data.id,

        nome: data.fields.name,
        nome_mae: data.fields.nome_mae,
        nome_pai: data.fields.nome_pai,
        cor: data.fields.cor,
        genero: data.fields.genero,
        cpf: data.fields.cpf,
        data_nascimento: data.fields.data_nascimento,
        contato: data.fields.contato,
        rg: data.fields.rg,
        orgao_emissor: data.fields.orgao_emissor,
        orgao_emissor_uf: data.fields.orgao_emissor_uf,
        nacionalidade: data.fields.nacionalidade,
        naturalidade_municipio: data.fields.naturalidade_municipio,
        naturalidade_uf: data.fields.naturalidade_uf,
        nome_ies: data.fields.nome_ies,
        data_conclusao_ies: data.fields.data_conclusao_ies,
        cep: data.fields.cep,
        endereco: data.fields.endereco,
        endereco_uf: data.fields.endereco_uf,
        municipio: data.fields.municipio,
        bairro: data.fields.bairro,
        complemento: data.fields.complemento,

        // Documentos
        doc_identidade: data.files.doc_identidade,
        doc_cpf: data.files.doc_cpf,
        doc_diploma: data.files.doc_diploma,
        doc_certidao_casamento: data.files.doc_certidao_casamento,

        observacao: data.observacao,
      })
      .then((response) => {
        return response.data;
      });
  }

  getDocument(userId, type) {
    const instance = createInstance({ responseType: "blob" });
    const user = JSON.parse(localStorage.getItem("user") || "{}");
    const { token } = user;

    return instance
      .get(API_URL + "/docs/" + userId + "/" + type, {
        headers: {
          Authorization: `Bearer ${token}`
        }
      })
      .then((response) => {
        return response;
      }).catch((error) => {
        return error
      });
  }
}

export default new Supervisor();
